export const DCF_CANCEL_RESPONSE_RECEIVED = 'dcf_cancel_response_received_srcsystem';
export const DCF_FAILURE_RESPONSE_RECEIVED = 'dcf_failure_response_received_srcsystem';
export const DCF_REQUEST_SENT = 'srcsystem_checkout_request_sent_dcf';
export const DCF_SUCCESS_RESPONSE_RECEIVED = 'dcf_success_response_received_srcsystem';
export const MESSAGE_DELIMITER = '--';
export const SRC_CANCEL_RESPONSE_RECEIVED = 'srcsystem_cancel_response_received_srci';
export const SRC_CANCEL_RESPONSE_SENT = 'srcsystem_cancel_response_sent_srci';
export const SRC_FAILURE_RESPONSE_RECEIVED = 'srcsystem_failure_response_received_srci';
export const SRC_FAILURE_RESPONSE_SENT = 'srcsystem_failure_response_sent_srci';
export const SRC_SUCCESS_RESPONSE_RECEIVED = 'srcsystem_success_response_received_srci';
export const SRC_SUCCESS_RESPONSE_SENT = 'srcsystem_success_response_sent_srci';
export const SRCI_CANCEL_RESPONSE = 'srcsystem_cancel_response';
export const SRCI_FAILURE_RESPONSE = 'srcsystem_failure_response';
export const SRCI_REQUEST_RECEIVED = 'srci_checkout_request_received_srcsystem';
export const SRCI_SUCCESS_RESPONSE = 'srcsystem_success_response';
export const SYS_PUSH_GTM_DATA_EVENT = 'visa.src.push-gtm-data';
export const SYS_SYNC_GTM_DATA_EVENT = 'visa.src.sync-gtm-data';
export const THM_PROFILING = 'THM Profiling';
